/**
 * Duplicate repo URL gate: origin deprecated (use copy) or existing copy (ack / cancel).
 */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { AlertTriangle, ExternalLink, X } from 'lucide-react';
import '../AIGarage.css';

const RepoUrlGateModal = ({
  isOpen,
  gate,
  onUseCopyUrl,
  onAcknowledge,
  onCancel,
  acknowledging = false,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || acknowledging) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, acknowledging, onCancel]);

  if (!isOpen || !gate) return null;

  const isOrigin = gate.code === 'origin_deprecated';
  const copyUrl = (gate.garageCopyUrl || '').trim();

  const modalContent = (
    <div className="garage-modal-overlay" onClick={acknowledging ? undefined : onCancel}>
      <div className="garage-modal garage-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="garage-modal-header">
          <div className="garage-modal-title-row">
            <div className="garage-modal-icon">
              <AlertTriangle size={24} color="#F59E0B" />
            </div>
            <h2>{isOrigin ? 'Origin repo deprecated' : 'Garage copy already exists'}</h2>
          </div>
          <button
            type="button"
            className="garage-modal-close"
            onClick={onCancel}
            disabled={acknowledging}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
        <div className="garage-modal-body">
          <p style={{ marginTop: 0 }}>{gate.message}</p>
          {copyUrl ? (
            <p className="it-scan-copy-link" style={{ wordBreak: 'break-all' }}>
              <a href={copyUrl} target="_blank" rel="noreferrer">
                {copyUrl} <ExternalLink size={12} />
              </a>
            </p>
          ) : null}
        </div>
        <div className="garage-modal-actions">
          <button
            type="button"
            className="garage-btn garage-btn-secondary"
            onClick={onCancel}
            disabled={acknowledging}
          >
            Cancel submission
          </button>
          {isOrigin ? (
            <button
              type="button"
              className="garage-btn garage-btn-primary"
              onClick={() => onUseCopyUrl?.(copyUrl)}
              disabled={!copyUrl || acknowledging}
            >
              Use garage-apps URL
            </button>
          ) : (
            <button
              type="button"
              className="garage-btn garage-btn-primary"
              onClick={() => onAcknowledge?.()}
              disabled={acknowledging}
            >
              {acknowledging ? 'Continuing…' : 'Continue with this copy'}
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default RepoUrlGateModal;
